import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmTool } from "@/mixins/index";
import { addQuestionnaire, updateQuestionnaire } from "@/api/gmtool/packageCode";
export default {
  mixins: [gmTool],
  data: function data() {
    var _rules;

    return {
      dialogShow: false,
      resizeObserver: null,
      scrollHeight: 0,
      formData: {
        title: '',
        desc: '',
        start_time: '',
        end_time: '',
        language: '',
        server_range: [],
        isLimit: false,
        condition: [{
          k: '',
          v: ''
        }],
        questions: [],
        award: []
      },
      isdisabled: false,
      rules: (_rules = {
        title: [{
          required: true,
          message: this.$t('pleaseInputTitle'),
          trigger: "blur"
        }],
        desc: [{
          required: true,
          message: this.$t('pleaseInputDesc'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }],
        start_time: [{
          required: true,
          message: this.$t('pleaseSelectStartTime'),
          trigger: "blur"
        }],
        end_time: [{
          required: true,
          message: this.$t('pleaseSelectEndTime'),
          trigger: "blur"
        }],
        server_range: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: this.$t('pleaseInputValue'),
          trigger: "blur"
        }],
        required: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }]
      }, _defineProperty(_rules, "desc", [{
        required: true,
        message: this.$t('pleaseChoose'),
        trigger: "blur"
      }]), _defineProperty(_rules, "word_limit_max", [{
        required: true,
        message: this.$t('pleaseInput'),
        trigger: "blur"
      }]), _defineProperty(_rules, "word_limit_min", [{
        required: true,
        message: this.$t('pleaseInput'),
        trigger: "blur"
      }]), _defineProperty(_rules, "max_select", [{
        required: true,
        message: this.$t('pleaseInput'),
        trigger: "blur"
      }]), _rules)
    };
  },
  mounted: function mounted() {},
  methods: {
    open: function open(getData, type) {
      if (type) {
        this.isdisabled = true;
      } else {
        this.isdisabled = false;
      }

      console.log("data==", getData);

      if (getData) {
        var data = JSON.parse(JSON.stringify(getData));
        var formattedCondition = [];

        if (data.condition.length) {
          formattedCondition = data.condition.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              k: String(item.k) // 核心：转成数字类型

            });
          });
        }

        var questions = data.questions;
        questions = questions.map(function (question, qIndex) {
          return _objectSpread(_objectSpread({}, question), {}, {
            type: String(question.type)
          });
        });
        var newData = {
          id: data.id,
          title: data.title,
          desc: data.desc,
          start_time: data.start_time,
          isLimit: formattedCondition.length > 0 ? true : false,
          end_time: data.end_time,
          language: data.language,
          server_range: data.server_range.split(",").map(Number),
          // is_prod: data.is_prod,
          condition: formattedCondition.length > 0 ? formattedCondition : [{
            k: '',
            v: ''
          }],
          questions: questions,
          award: data.award || []
        };
        this.paramsData.is_prod = data.is_prod;
        this.formData = _objectSpread({}, newData);
        console.log("this.formData==", this.formData);
      }

      this.Renewal();
      this.dialogShow = true;
      setTimeout(function () {
        var dialogs = document.querySelectorAll('.dialogs');
        dialogs.forEach(function (dialog) {
          dialog.style.paddingTop = '0';
          dialog.style.paddingBottom = '0';
          dialog.style.position = 'fixed';
        });
      }, 100);
    },
    isOptionDisabled: function isOptionDisabled(val, currentIndex) {
      return this.formData.condition.some(function (item, i) {
        return i !== currentIndex && String(item.k) === String(val);
      });
    },
    Renewal: function Renewal() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.paramsData.server_id = [];
                _context.next = 3;
                return _this.getserverList();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 限制条件逻辑
    addLimit: function addLimit() {
      this.formData.condition.push({
        k: '',
        v: ''
      });
    },
    removeLimit: function removeLimit(index) {
      this.formData.condition.splice(index, 1);
    },
    addReward: function addReward() {
      this.formData.award.push({
        id: '',
        num: ''
      });
    },
    removeReward: function removeReward(index) {
      this.formData.award.splice(index, 1);
    },
    selectAllServers: function selectAllServers() {
      this.formData.server_range = this.serverMergeList.map(function (i) {
        return i.serverID;
      });
    },
    toggleInvertSelect: function toggleInvertSelect() {
      var _this2 = this;

      var allServerIds = this.serverMergeList.map(function (i) {
        return i.serverID;
      }); // 获取当前未选中的服务器ID

      var unselectedIds = allServerIds.filter(function (id) {
        return !_this2.formData.server_range.includes(id);
      });
      this.formData.server_range = unselectedIds;
    },
    // 题目逻辑
    addQuestion: function addQuestion() {
      this.formData.questions.push({
        title: '',
        required: false,
        type: "1",
        max_select: 1,
        options: [{
          desc: '',
          type: 1
        }]
      }); // 新增题目后自动滚动到底部，并重新计算高度

      this.$nextTick(function () {
        var container = document.querySelector('.question-scroll-container');

        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    removeQuestion: function removeQuestion(index) {
      this.formData.questions.splice(index, 1);
    },
    handleTypeChange: function handleTypeChange(q) {
      if (q.type == 2) {
        q.options = [{
          desc: '',
          type: 2,
          word_limit_min: 1,
          word_limit_max: 100
        }];
      } else {
        q.options = [{
          desc: '',
          type: 1
        }];
      }
    },
    submitForm: function submitForm() {
      var _this3 = this;

      console.log("this.formData+++", this.formData);
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          console.log("this.formData==", _this3.formData);
          var params = JSON.parse(JSON.stringify(_this3.formData));
          var questions = params.questions;
          questions = questions.map(function (question, qIndex) {
            return _objectSpread(_objectSpread({}, question), {}, {
              type: Number(question.type),
              id: qIndex + 1,
              // 题目id从1开始
              options: question.options.map(function (option, oIndex) {
                return _objectSpread(_objectSpread({}, option), {}, {
                  id: oIndex + 1 // 选项id从1开始

                });
              })
            });
          });
          var formattedCondition = [];

          if (params.isLimit == true) {
            formattedCondition = params.condition.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                k: Number(item.k) // 核心：转成数字类型

              });
            });
          }

          var award = params.award;
          award = award.map(function (award, aIndex) {
            return {
              id: Number(award.id),
              num: Number(award.num)
            };
          });
          var sendParams = {
            id: params.id,
            title: params.title,
            desc: params.desc,
            start_time: params.start_time,
            end_time: params.end_time,
            language: params.language,
            server_range: params.server_range.join(","),
            is_prod: _this3.paramsData.is_prod,
            condition: formattedCondition,
            questions: questions,
            award: award
          };
          var req = _this3.formData.id ? updateQuestionnaire : addQuestionnaire;
          req(sendParams).then(function (res) {
            if (res.status == 200) {
              _this3.$Message.success(_this3.$t('operationSuccess'));

              _this3.$emit("change");

              _this3.dialogShow = false;
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.formData = {
        title: '',
        desc: '',
        start_time: '',
        end_time: '',
        language: '',
        server_range: [],
        isLimit: false,
        condition: [{
          k: '',
          v: ''
        }],
        questions: [],
        award: []
      };
    }
  }
};